import { render, staticRenderFns } from "./UpdateForm1.vue?vue&type=template&id=6b0b6cb4"
import script from "./UpdateForm1.vue?vue&type=script&lang=js"
export * from "./UpdateForm1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports